"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANAGED_CREATIVE_PLANS = exports.ONBOARDING_PLAN_LABEL = exports.NEW_ORG_PLANS = exports.ONBOARDING_PLANS = void 0;
exports.isNewOrgPlan = isNewOrgPlan;
exports.isManagedCreativePlan = isManagedCreativePlan;
exports.planOnboardsInInternalSetup = planOnboardsInInternalSetup;
exports.planCollectsBrandDocs = planCollectsBrandDocs;
/**
 * Onboarding plans: the one list the invite form, the tracker's org cards and
 * every routing gate read from.
 *
 * Mirrors the Prisma `OnboardingPlan` enum; the db package is not a dependency
 * here, so the values are repeated and pinned by a test on the backend side.
 */
exports.ONBOARDING_PLANS = [
    "ENTERPRISE_AUDIT",
    "FULL_CREATIVE",
    "CREATIVE_ONLY",
    "MANAGED_MEDIA",
    "FRAMEWORK_ONLY",
    "NEWFORM_ONE",
];
/**
 * The plans a new org can be put on, in the order staff pick from. Enterprise
 * audit is the legacy audit-first plan: existing orgs keep it, nothing new
 * starts on it.
 */
exports.NEW_ORG_PLANS = [
    "FRAMEWORK_ONLY",
    "CREATIVE_ONLY",
    "MANAGED_MEDIA",
    "FULL_CREATIVE",
    "NEWFORM_ONE",
];
exports.ONBOARDING_PLAN_LABEL = {
    FRAMEWORK_ONLY: "Framework only",
    CREATIVE_ONLY: "Creative only",
    MANAGED_MEDIA: "Managed media",
    FULL_CREATIVE: "Full creative",
    NEWFORM_ONE: "NewForm One",
    ENTERPRISE_AUDIT: "Enterprise audit (legacy)",
};
function isNewOrgPlan(plan) {
    return exports.NEW_ORG_PLANS.some((candidate) => candidate === plan);
}
/**
 * The managed creative plans: NewForm's team makes the ads, so the client
 * goes through the full-service intake and team review before going live,
 * NewForm runs their Slack channels, and the launch kickoff email fires on
 * the agreed launch date. Creative only and Managed media differ in what the
 * media team does after launch, not in how the client is onboarded.
 */
exports.MANAGED_CREATIVE_PLANS = [
    "FULL_CREATIVE",
    "CREATIVE_ONLY",
    "MANAGED_MEDIA",
];
function isManagedCreativePlan(plan) {
    return exports.MANAGED_CREATIVE_PLANS.some((candidate) => candidate === plan);
}
/**
 * The whole client onboarding is the internal setup wizard at `/onboarding`:
 * there is no client-intake route before it and no team review gate after it,
 * so `completedFrameworkClientIntake` is stamped true at provisioning and the
 * wizard's last step is what takes the org live.
 */
function planOnboardsInInternalSetup(plan) {
    return plan === "FRAMEWORK_ONLY" || plan === "NEWFORM_ONE";
}
/**
 * The onboarding asks the client for the full-service brand material (the
 * Creative Testing, Brand Deep Dive, Performance Deep Dive and Compliance docs)
 * and keeps a `FullServiceOnboarding` row to hold it. Managed creative clients
 * upload it on the way to team review; NewForm One clients upload it as a step
 * of the setup wizard, because creators work from the same material.
 */
function planCollectsBrandDocs(plan) {
    return isManagedCreativePlan(plan) || plan === "NEWFORM_ONE";
}
